"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getClassQuestionFromMission = getClassQuestionFromMission;
exports.getClassQuestionIdFromMission = getClassQuestionIdFromMission;
exports.getCulminatingMomentDataFromMission = getCulminatingMomentDataFromMission;
exports.getCulminatingMomentResponses = getCulminatingMomentResponses;
exports.getCulminatingMomentResultFromMission = getCulminatingMomentResultFromMission;
exports.getIsClassQuestionScreenFromMission = getIsClassQuestionScreenFromMission;
exports.getStudentClassQuestionResponsesFromMission = getStudentClassQuestionResponsesFromMission;
var _functions = require("../utility/functions");
/**
 * Whether or not the current screen on the mission is a class question
 * @param {?SharedMissionStateSelectorState} missionState
 * @returns {boolean}
 */
function getIsClassQuestionScreenFromMission(missionState) {
  if (!missionState) return false;
  return Boolean(missionState.launchpad.screen && missionState.launchpad.screen.type === 'CULMINATING_MOMENT');
}

/**
 * Gets the current questionInfo (question phrase, options, and details) related to the culminating moment
 * @param {?SharedMissionStateSelectorState} missionState
 * @returns {?QuestionInfo}
 */
function getClassQuestionFromMission(missionState) {
  return missionState?.launchpad.screen && missionState.launchpad.screen.type === 'CULMINATING_MOMENT' ? missionState.launchpad.screen.questionInfo : null;
}

/**
 * Gets the current class question action id from a given mission
 * @param {?SharedMissionStateSelectorState} missionState
 * @returns {?string}
 */
function getClassQuestionIdFromMission(missionState) {
  return missionState?.launchpad.screen && missionState.launchpad.screen.type === 'CULMINATING_MOMENT' ? missionState.launchpad.screen._actionId : null;
}

/**
 * Builds a map for the current class question:
 * Keys are option ids mapped to studentIds who responded to given option
 * @param {?SharedMissionStateSelectorState} missionState
 * @returns { {[optionId: string]: string[]} }
 */
function getStudentClassQuestionResponsesFromMission(missionState) {
  const culminatingMomentResponses = getCulminatingMomentResponses(missionState);
  let options = {};
  if (culminatingMomentResponses) {
    (0, _functions.forEachEntry)(culminatingMomentResponses, ([studentId, responseIds]) => {
      const lastResponseId = responseIds[responseIds.length - 1];
      if (lastResponseId) {
        if (!options[lastResponseId]) {
          options[lastResponseId] = [];
        }
        options[lastResponseId].push(studentId);
      }
    });
  }
  return options;
}

/**
 * Gets student response data for all culminating moments in the mission
 * @param {?SharedMissionStateSelectorState} missionState
 * @returns {?CulminatingMomentData}
 */
function getCulminatingMomentDataFromMission(missionState) {
  return missionState?.culminatingMomentData;
}

/**
 * Gets the single action id which will result from a culminating moment
 * @param {?SharedMissionStateSelectorState} missionState
 * @returns {?string}
 */
function getCulminatingMomentResultFromMission(missionState) {
  if (!missionState || missionState.launchpad.screen?.type !== 'CULMINATING_MOMENT') {
    return null;
  }
  return missionState.launchpad.screen.result || null;
}

/**
 * Gets student response data fro the current class question, or question id provided
 * @param {?SharedMissionStateSelectorState} missionState
 * @param {?string} questionId
 * @returns {?{ [studentId: string]: string[] }}
 */
function getCulminatingMomentResponses(missionState, questionId) {
  const classQuestionId = questionId || getClassQuestionIdFromMission(missionState);
  if (classQuestionId) {
    return getCulminatingMomentDataFromMission(missionState)?.[classQuestionId]?.responses;
  }
  return null;
}